<ion-chip color="dark" ngxTippy="Completed Work Orders">
  <ion-icon name="checkmark-circle"></ion-icon>
  ii
  <strong>{{ user.completedWorkOrders }}</strong>
</ion-chip>
